// extracted by mini-css-extract-plugin
export default {"root":"_3Xd1C","first-row":"_12Q9B","firstRow":"_12Q9B","second-row":"hbOXW","secondRow":"hbOXW"};